<template>
  <div>
    <Files
      :father-id="father_id"
      @loading="toggleLoading"
    />
    <Loading
      :active="loadingShow"
      :is-full-page="false"
      :opacity="0.8"
      background-color="#161D31"
    >
      <div slot="default">
        <BSpinner
          style="width: 3rem; height: 3rem;"
          type="grow"
          variant="primary"
        />
      </div>
    </Loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { BSpinner } from 'bootstrap-vue'
import Files from '../layouts/components/Files.vue'

export default {
  name: 'SecondPage',
  components: {
    Files,
    Loading,
    BSpinner,
  },
  data() {
    return {
      loadingShow: false,
      father_id: 0,
    }
  },
  methods: {
    log(message) {
      console.log(message)
    },
    toggleLoading(show) {
      this.loadingShow = show
    },
  },
}
</script>

<style>

</style>
